import { jsx } from "react/jsx-runtime";
import { Link as Link$1 } from "react-router";
import { replaceNavigateToPattern } from "../../lib/router/replaceNavigateToPattern.js";
function Link({ to, params, ...props }) {
  return /* @__PURE__ */ jsx(Link$1, { to: replaceNavigateToPattern(to, params), ...props });
}
export {
  Link
};
